export class DataCatalogPipelineDefinition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sources",
            "baseName": "sources",
            "type": "Array<DataCatalogPipelineSource>",
            "format": ""
        },
        {
            "name": "output",
            "baseName": "output",
            "type": "DataCatalogPipelineOutput",
            "format": ""
        },
        {
            "name": "engine",
            "baseName": "engine",
            "type": "DataCatalogPipelineEngine",
            "format": ""
        },
        {
            "name": "resolvedDatasets",
            "baseName": "resolvedDatasets",
            "type": "Array<DataCatalogPipelineResolvedDataset>",
            "format": ""
        },
        {
            "name": "outputColumns",
            "baseName": "outputColumns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "incrementalAlias",
            "baseName": "incrementalAlias",
            "type": "string",
            "format": ""
        },
        {
            "name": "incrementalRefusal",
            "baseName": "incrementalRefusal",
            "type": "string",
            "format": ""
        },
        {
            "name": "resolvedGroups",
            "baseName": "resolvedGroups",
            "type": "Array<DataCatalogPipelineResolvedGroup>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogPipelineDefinition.attributeTypeMap;
    }
    constructor() {
    }
}
